import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { showAllOrdersOfProfessionalMySolution } from '../../../../../../../actions/ProfessionalMySolutionActions';
import { propBool, propFunc, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../../../helpers/recompose';
import ProfessionalMyPageTopMySolutionItemBodyRow from './MySolutionItemBodyRow';
const ProfessionalMyPageTopMySolutionItemBody = ({ item, mode, profile, show, showAllOrders, }) => (_jsxs("div", Object.assign({ className: `my-solution-detail ${show ? 'is-opened' : ''}` }, { children: [(mode === 'all' ? item.orders : item.orders.slice(0, 3)).map((order) => (_jsx(ProfessionalMyPageTopMySolutionItemBodyRow, { order: order, profile: profile, solution: item.solution }, order.id))), mode === 'view' && item.orders.length > 3 && (_jsx("div", Object.assign({ className: 'detail-more' }, { children: _jsx("button", Object.assign({ className: 'link-text', onClick: showAllOrders, type: 'button' }, { children: "\u3082\u3063\u3068\u898B\u308B" })) })))] })));
ProfessionalMyPageTopMySolutionItemBody.propTypes = {
    item: propShape().isRequired,
    mode: propStr().isRequired,
    profile: propShape().isRequired,
    show: propBool().isRequired,
    showAllOrders: propFunc().isRequired,
};
const mapStateToProps = ({ professionalMySolution }, { item }) => {
    const expansion = professionalMySolution.orderExpansions[item.solution.id] || {};
    return {
        mode: expansion.mode || 'view',
        show: expansion.show || false,
    };
};
const mapDispatchToProps = (dispatch, { item }) => ({
    showAllOrders: () => dispatch(showAllOrdersOfProfessionalMySolution(item.solution.id)),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(ProfessionalMyPageTopMySolutionItemBody);
